import React, { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";

// mailto link + small Copy fallback for visitors without a configured email app.
export default function EmailLink({ email, className = "", testId }) {
  const [copied, setCopied] = useState(false);
  const copy = async (e) => {
    e.preventDefault();
    try {
      await navigator.clipboard.writeText(email);
      setCopied(true);
      toast.success("Email address copied");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      window.prompt("Copy this email address:", email);
    }
  };
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <a href={`mailto:${email}`} className="hover:text-[#C19B6C] break-all" data-testid={testId}>{email}</a>
      <button type="button" onClick={copy} aria-label={`Copy ${email}`} title="Copy email" className="text-neutral-500 hover:text-[#C19B6C] transition-colors" data-testid={testId ? `${testId}-copy` : undefined}>
        {copied ? <Check size={13} /> : <Copy size={13} />}
      </button>
    </span>
  );
}
